var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C10.1435 3 8.36302 3.7375 7.05027 5.05025C5.73751 6.36301 5.00002 8.14348 5.00002 10C5.00002 13.3527 4.28295 15.4346 3.62212 16.6461C3.29033 17.2544 2.96724 17.6535 2.74281 17.8904C2.63034 18.0091 2.54195 18.0878 2.48874 18.1322C2.46212 18.1544 2.44426 18.168 2.43656 18.1737L2.43371 18.1758C2.07522 18.4221 1.91658 18.8725 2.04292 19.2898C2.17062 19.7115 2.55935 20 3.00002 20H21C21.4407 20 21.8294 19.7115 21.9571 19.2898C22.0835 18.8725 21.9248 18.4221 21.5663 18.1758L21.5635 18.1737C21.5558 18.168 21.5379 18.1544 21.5113 18.1322C21.4581 18.0878 21.3697 18.0091 21.2572 17.8904C21.0328 17.6535 20.7097 17.2544 20.3779 16.6461C19.7171 15.4346 19 13.3527 19 10C19 8.14349 18.2625 6.36301 16.9498 5.05025C15.637 3.7375 13.8565 3 12 3ZM18.6221 17.6039C18.6982 17.7434 18.7746 17.8753 18.8507 18H5.14934C5.22543 17.8753 5.30181 17.7434 5.37791 17.6039C6.21708 16.0654 7.00002 13.6473 7.00002 10C7.00002 8.67392 7.5268 7.40215 8.46448 6.46447C9.40216 5.52678 10.6739 5 12 5C13.3261 5 14.5979 5.52678 15.5356 6.46447C16.4732 7.40215 17 8.67392 17 10C17 13.6473 17.7829 16.0654 18.6221 17.6039ZM11.135 22.4982C10.8579 22.0205 10.246 21.8579 9.76826 22.135C9.29054 22.4121 9.12792 23.024 9.40504 23.5018C9.66875 23.9564 10.0473 24.3337 10.5027 24.5961C10.9581 24.8584 11.4745 24.9965 12 24.9965C12.5256 24.9965 13.042 24.8584 13.4974 24.5961C13.9528 24.3337 14.3313 23.9564 14.595 23.5018C14.8722 23.024 14.7095 22.4121 14.2318 22.135C13.7541 21.8579 13.1422 22.0205 12.865 22.4982C12.7771 22.6498 12.651 22.7756 12.4991 22.863C12.3473 22.9504 12.1752 22.9965 12 22.9965C11.8248 22.9965 11.6527 22.9504 11.5009 22.863C11.3491 22.7756 11.2229 22.6498 11.135 22.4982Z",
    fill: "url(#paint0_linear_1759_6161)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3334,
    cy: 6,
    r: 5,
    fill: "#F44336",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1759_6161",
    x1: 10.0562,
    y1: 24.9965,
    x2: 14.723,
    y2: 3.16658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOn);
export default __webpack_public_path__ + "static/media/NotificationOn.8e41ca7adfc5d0637cb5fd9d355abc1d.svg";
export { ForwardRef as ReactComponent };